import React, { Component } from 'react';
import { Upload, Modal, Icon, message, Button, Input, Select, Popover, Alert } from 'antd';
import {
  ModalBody,
  Container,
  InputLabel,
  InputContainer,
  AddNewCategory,
  PopupContainer,
  PopupActionContainer,
  PopupLabel,
  SaveButton,
  CancelButton,
  UploadImageContainer,
  ModalContainer,
  BulkUploadContainer,
  BulkUploadButton,
  UploadButtonWrapper,
  UploadListWrapper,
  UploadInputContainer,
  UploadActionContainer,
  BulkuploadErrorAlert,
} from './styles';
import { v4 as uuidv4 } from 'uuid';
import URL from '../../utils/helper';
import { getBase64, getFileBlob, getImageDimensions } from '../../utils/javascript';
import { saveThumbnail } from '../../utils/services/thumbnailAPI';
import { saveElement } from '../../utils/services/elementAPI';
import { getAllCategories, createCategory } from '../../utils/services/categoriesAPI';
import { withTranslation } from 'react-i18next';
import { MULTIPLE_FILE_UPLOAD_MODAL } from './translationValues';
import { AppStoreContext } from '../../context/appStoreContext';

const NAMESPACES = [ 'MULTIPLE_FILE_UPLOAD_MODAL'];

const { Option } = Select;
const accept = '.png,.jpeg,.jpg,.svg';
const acceptedExtension = ['png', 'jpeg', 'jpg', 'svg'];
class MultipleFileUploadModal extends Component {
  constructor(props) {
    super(props);
    this.previousContext = null;
    this.state = {
      loading: false,
      allCategories: [],
      selectedCategoryId: null,
      savePopupVisible: false,
      newCategoryName: null,
      validCategName: false,
      savingCategory: false,
      fileList: [],
      elementModalVisibility: false,
      isSaving: false,
      isAlertVisible: false,
    };
  }

  async componentDidMount() {
    this.setState({ userType: this.context.userDetails.userType });
    const response = await getAllCategories(false, 'element');
    if (response && response.data) {
      let loggedUserCategory = response.data.filter(
        categoryObj => this.state.userType === categoryObj.categoryusertype,
      );
      this.setState({
        allCategories: loggedUserCategory,
      });
    }
  }

  handleCancel = () => {
    this.setState({ selectedCategoryId: null, elementModalVisibility: false });
  };

  handlePopupVisibleChange = visible => {
    this.setState({
      savePopupVisible: visible,
      newCategoryName: null,
    });
  };

  saveNewCategory = () => {
    this.setState({
      savingCategory: true,
    });
    let payload = {
      name: this.state.newCategoryName,
      type: 'element',
    };
    this.createNewCategory(payload);
  };

  createNewCategory = async payload => {
    let categoryResponse = await createCategory(payload);
    if (categoryResponse && categoryResponse.errors && categoryResponse.errors.length === 0) {
      const savedCategory = {
        createdBy: null,
        createdOn: null,
        elements: null,
        id: categoryResponse.id,
        categoryusertype: this.state.userType,
        name: payload.name,
        parentId: 0,
        status: 'active',
        type: 'element',
        updatedBy: null,
        updatedOn: null,
      };
      this.setState({
        allCategories: [...this.state.allCategories, savedCategory],
        savePopupVisible: false,
        selectedCategoryId: categoryResponse.id,
        savingCategory: false,
        newCategoryName: null,
      });
    } else {
      this.setState({
        savingCategory: false,
      });
    }
  };

  saveNewElements = async () => {
    let newElementsArray = JSON.parse(JSON.stringify(this.state.fileList));
    let filterUploads = newElementsArray.filter(fileObj => {
      return fileObj.status !== 'error';
    });
    const uploadedStatus = await Promise.all(filterUploads.map(async element => {
      element.categoryId = this.state.selectedCategoryId;
      const success = await this.handleJSONObjConstruction(element);
      return ({ element, success });
    }));
    const failureUploads = uploadedStatus.filter(status => !status.success);
    this.handleCancel();
    if (failureUploads.length === 0) {
      this.props.onCancel();
    } else {
      this.setState({ fileList: failureUploads.map(status => status.element) });
    }
  };

  handleJSONObjConstruction = async data => {
    const newElement = {
      type: data.type,
      categoryId: data.categoryId,
      shareType: 'department',
      name: data.name,
      thumbnail: data.url,
      referenced: false
    };
    if (this.state.userType === 'client') {
      newElement.elementType = 'userElement';
    } else {
      newElement.elementType = 'masterElement';
    }
    let constructedElementJson = {
      type: "image",
      uiType: "image",
      tagName: "image",
      tagValue: data.url,
      value: data.url,
      tagStyles: {
        backgroundColor: [0, 0, 0, 0],
        width: parseInt(data.width.replaceAll('px', '')),
        height: parseInt(data.height.replaceAll('px', '')),
        translateX: 1,
        translateY: 1,
        rotate: 0,
        scaleX: 1,
        scaleY: 1
      },
      styles: {
        backgroundColor: 'transparent',
        position: 'absolute',
        transform: 'translateX(1) translateY(1) rotate(0deg) scaleX(1) scaleY(1)',
      }
    };
    newElement.element = constructedElementJson;
    this.setState({ isSaving: true });
    let elementResponse = await saveElement(newElement);
    if (elementResponse && elementResponse.statusCode && elementResponse.statusCode === 401) {
      message.success(elementResponse.status);
      this.setState({ isSaving: false });
      return true;
    } else if (elementResponse.errors[0]) {
      this.setState({ isSaving: false });
      return false;
    }
    this.setState({ isSaving: false });
    return false;
  };

  customRequest = async ({ file, onSuccess }) => {
    const { fileList } = this.state;
    let fileName = file.name.split('.');
    let fileType = file.type.replace('/', ',').split(',');
    const newFile = {
      uid: uuidv4(),
      name: fileName[0],
      type: fileType[0],
      isLoading: true,
      url: undefined,
      uploadId: undefined,
      status: undefined,
    };
    let fileExtension = file.name.split('.')[file.name.split('.').length - 1].toLowerCase();
    let isValidFileExtension = acceptedExtension.some(data => {
      return data === fileExtension;
    });
    if (!isValidFileExtension) {
      message.error(`${this.props.t(MULTIPLE_FILE_UPLOAD_MODAL.NOT_SUPPORTED_FILE_UPLOADED_ERROR_MESSAGE.key,MULTIPLE_FILE_UPLOAD_MODAL.NOT_SUPPORTED_FILE_UPLOADED_ERROR_MESSAGE.value)}${acceptedExtension.join(", ")}`);
    } else {
      this.setState(
        {
          fileList: [...fileList, newFile],
        },
        async () => {
          const url = await getBase64(file);
          const data = { file, thumbnail: url, name: file.name, id: uuidv4() };
          const uploadImageId = await this.onSubmit(data);
          const imgUrl = `${URL.BASE_URL}thumbnail?id=${uploadImageId}`;
          const dimensions = await getImageDimensions(url);
          let updatedList = this.state.fileList.map(fileObj => {
            if (fileObj.uid === newFile.uid) {
              return {
                ...newFile,
                isLoading: false,
                url: imgUrl,
                uploadId: uploadImageId,
                status: uploadImageId ? 'done' : 'error',
                ...dimensions
              };
            }
            return fileObj;
          });

          let filterUploads = updatedList.filter(fileObj => {
            return fileObj.status !== 'error';
          });

          this.setState({
            fileList: updatedList,
            isAlertVisible: updatedList.length > filterUploads.length ? true : false,
          });
        },
      );
    }
    onSuccess('ok');
  };

  onSubmit = async data => {
    console.log(data.file,data.name,'multiuplooad');
    let fileBlob = await getFileBlob(data.file);
    let response = await saveThumbnail(fileBlob);
    if (response && response.errors && response.errors.length === 0) {
      return response.id;
    }
  };

  handleFilechange = (e, id) => {
    const { fileList } = this.state;
    let testData = JSON.parse(JSON.stringify(fileList));
    testData[id].name = e.target.value;
    this.setState({
      fileList: testData,
    });
  };

  handleFileDelete = id => {
    let newFilterFileList = this.state.fileList.filter(element => {
      return element.uid !== id;
    });

    this.setState({
      fileList: newFilterFileList,
    });
  };

  handleClose = () => {
    this.setState({ isAlertVisible: false });
  };

  setCategoryName = categoryName => {
    this.setState({ newCategoryName: categoryName})
    this.setState({ validCategName: categoryName.split(" ").join("").length})
  };

  render() {
    const { onCancel, visible, t } = this.props;
    const {
      fileList,
      selectedCategoryId,
      newCategoryName,
      validCategName,
      savingCategory,
      allCategories,
      savePopupVisible,
      elementModalVisibility,
      isSaving,
    } = this.state;

    const filterFileList = this.state.fileList.filter(fileObj => {
      return fileObj.status !== 'error';
    });
    return (
      <>
        <Container onKeyDown={e => e.stopPropagation()}>
          <Modal
            centered
            maskClosable={false}
            visible={visible}
            width="1025px"
            onCancel={onCancel}
            footer={[
              <Button key="back" onClick={onCancel}>
                 {t(MULTIPLE_FILE_UPLOAD_MODAL.CANCEL_BUTTON.key, MULTIPLE_FILE_UPLOAD_MODAL.CANCEL_BUTTON.value)} 
              </Button>,
              <Button
                key="submit"
                type="primary"
                disabled={filterFileList.length === 0 ? true : false}
                onClick={() => this.setState({ elementModalVisibility: true })}
              >
                {t(MULTIPLE_FILE_UPLOAD_MODAL.UPLOAD_ELEMENT_BUTTON.key, MULTIPLE_FILE_UPLOAD_MODAL.UPLOAD_ELEMENT_BUTTON.value)} ({filterFileList.length})
              </Button>,
            ]}
            className="warning-modal"
          >
            <BulkUploadContainer>
              <UploadButtonWrapper>
                <Upload
                  multiple={true}
                  fileList={fileList}
                  customRequest={this.customRequest}
                  showUploadList={false}
                  accept={accept}
                >
                  <BulkUploadButton initialUpload={fileList.length === 0 ? true : false}>
                    <div>
                      <Icon type="cloud-upload" />
                    </div>
                    <p>{t(MULTIPLE_FILE_UPLOAD_MODAL.DRAG_AND_DROP_ACTION.key, MULTIPLE_FILE_UPLOAD_MODAL.DRAG_AND_DROP_ACTION.value)}</p>
                  </BulkUploadButton>
                </Upload>
              </UploadButtonWrapper>
              <UploadListWrapper>
                {fileList.map((file, index) => {
                  if (file.isLoading) {
                    return (
                      <UploadImageContainer key={index}>
                        <Icon type="loading" />
                      </UploadImageContainer>
                    );
                  }
                  return (
                    <UploadActionContainer key={index}>
                      <UploadImageContainer errorFile={file.status === 'error' ? true : false}>
                        <div className="upload-image">
                          <img src={file.url} alt="uploadedImage" />
                        </div>
                        <div className="editor-area">
                          <Icon type="delete" onClick={() => this.handleFileDelete(file.uid)} />
                        </div>
                        <div className="overlay"></div>
                      </UploadImageContainer>
                      <UploadInputContainer errorFile={file.status === 'error' ? true : false}>
                        <Input
                          name="filename"
                          value={file.name}
                          onChange={e => this.handleFilechange(e, index)}
                          suffix={<Icon type="edit" />}
                          autocomplete="off"
                        />
                      </UploadInputContainer>
                    </UploadActionContainer>
                  );
                })}
              </UploadListWrapper>
              {this.state.isAlertVisible && fileList.length !== 0 && (
                <BulkuploadErrorAlert>
                  <Alert
                    message={t(MULTIPLE_FILE_UPLOAD_MODAL.UNABLE_TO_UPLOAD_FILE_ERROR_MESSAGE.key, MULTIPLE_FILE_UPLOAD_MODAL.UNABLE_TO_UPLOAD_FILE_ERROR_MESSAGE.value)}
                    type="error"
                    closable
                    afterClose={this.handleClose}
                  />
                </BulkuploadErrorAlert>
              )}
            </BulkUploadContainer>
          </Modal>
        </Container>
        <Modal
          visible={elementModalVisibility}
          title={t(MULTIPLE_FILE_UPLOAD_MODAL.UPLOAD_ELEMENT_TITLE.key, MULTIPLE_FILE_UPLOAD_MODAL.UPLOAD_ELEMENT_TITLE.value)}
          onCancel={this.handleCancel}
          footer={[
            <Button key="back" onClick={this.handleCancel}>
              {t(MULTIPLE_FILE_UPLOAD_MODAL.CANCEL_BUTTON.key, MULTIPLE_FILE_UPLOAD_MODAL.CANCEL_BUTTON.value)}
            </Button>,
            <Button
              key="submit"
              type="primary"
              disabled={!selectedCategoryId}
              loading={isSaving}
              onClick={() => this.saveNewElements()}
            >
              {isSaving ? t(MULTIPLE_FILE_UPLOAD_MODAL.UPLOAD_SAVING_TEXT.key, MULTIPLE_FILE_UPLOAD_MODAL.UPLOAD_SAVING_TEXT.value) : t(MULTIPLE_FILE_UPLOAD_MODAL.SAVE_BUTTON.key, MULTIPLE_FILE_UPLOAD_MODAL.SAVE_BUTTON.value)}
            </Button>,
          ]}
        >
          <ModalBody>
            <ModalContainer>
              <InputContainer>
                <AddNewCategory>
                  <Popover
                    content={
                      <PopupContainer>
                        <PopupLabel>{t(MULTIPLE_FILE_UPLOAD_MODAL.CATEGORY_NAME_LABEL.key, MULTIPLE_FILE_UPLOAD_MODAL.CATEGORY_NAME_LABEL.value)}</PopupLabel>
                        <Input
                          placeholder={t(MULTIPLE_FILE_UPLOAD_MODAL.CATEGORY_NAME_PLACEHOLDER.key, MULTIPLE_FILE_UPLOAD_MODAL.CATEGORY_NAME_PLACEHOLDER.value)}
                          autoComplete="off"
                          name="categoryName"
                          value={newCategoryName}
                          onChange={e => this.setCategoryName(e.target.value)}
                        />
                        <PopupActionContainer>
                          <CancelButton
                            size="default"
                            onClick={() => this.handlePopupVisibleChange(false)}
                          >
                            {t(MULTIPLE_FILE_UPLOAD_MODAL.CANCEL_BUTTON.key, MULTIPLE_FILE_UPLOAD_MODAL.CANCEL_BUTTON.value)}
                          </CancelButton>
                          <SaveButton
                            type="primary"
                            size="default"
                            onClick={() => this.saveNewCategory()}
                            disabled={!newCategoryName || !validCategName}
                            loading={savingCategory}
                          >
                            {savingCategory ? t(MULTIPLE_FILE_UPLOAD_MODAL.UPLOAD_SAVING_TEXT.key, MULTIPLE_FILE_UPLOAD_MODAL.UPLOAD_SAVING_TEXT.value) : t(MULTIPLE_FILE_UPLOAD_MODAL.SAVE_BUTTON.key, MULTIPLE_FILE_UPLOAD_MODAL.SAVE_BUTTON.value)}
                          </SaveButton>
                        </PopupActionContainer>
                      </PopupContainer>
                    }
                    placement="leftBottom"
                    trigger="click"
                    visible={savePopupVisible}
                    onVisibleChange={this.handlePopupVisibleChange}
                  >
                    <Icon type="plus" /> {t(MULTIPLE_FILE_UPLOAD_MODAL.ADD_NEW_ACTION.key, MULTIPLE_FILE_UPLOAD_MODAL.ADD_NEW_ACTION.value)}
                  </Popover>
                </AddNewCategory>
                <InputLabel>{t(MULTIPLE_FILE_UPLOAD_MODAL.CATEGORY_LABEL.key, MULTIPLE_FILE_UPLOAD_MODAL.CATEGORY_LABEL.value)}</InputLabel>
                <Select
                  loading={!allCategories}
                  showSearch
                  placeholder={t(MULTIPLE_FILE_UPLOAD_MODAL.SELECT_CATEGORY_PLACEHOLDER.key, MULTIPLE_FILE_UPLOAD_MODAL.SELECT_CATEGORY_PLACEHOLDER.value)}
                  optionFilterProp="children"
                  value={selectedCategoryId ? selectedCategoryId : undefined}
                  onChange={value => this.setState({ selectedCategoryId: value })}
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {this.state.allCategories &&
                    this.state.allCategories.map(data => {
                      return (
                        <Option key={String(data.id)} value={data.id}>
                          {data.name}
                        </Option>
                      );
                    })}
                </Select>
              </InputContainer>
            </ModalContainer>
          </ModalBody>
        </Modal>
      </>
    );
  }
}

MultipleFileUploadModal.contextType = AppStoreContext;
export default withTranslation(NAMESPACES)(MultipleFileUploadModal);
